import { tools } from "../data/tools";

export const SITE_URL = "https://purposelabs.in";
export const SITE_NAME = "Purpose Labs";
export const OG_IMAGE = `${SITE_URL}/photos/purposeLogo.png`;
export const THEME_COLOR = "#4f46e5";
export const API_URL =
  import.meta.env.VITE_API_URL || "https://seal-app-oz2hs.ondigitalocean.app";

export const siteConfig = {
  name: SITE_NAME,
  url: SITE_URL,
  description:
    "Purpose Labs delivers IT and research services worldwide — lead generation websites, booking platforms, custom CRMs, AI call agents, and free online tools.",
  keywords:
    "Purpose Labs, IT services, research services, web development, lead generation, booking platform, custom CRM, AI call agent, free online tools, worldwide",
  email: "master@purposelabs.in",
  phone: "+91-8178462090",
};

export const pageMeta = {
  home: {
    title: "Purpose Labs — IT & Research Services Worldwide",
    description:
      "Purpose Labs provides IT and research services worldwide — lead generation websites, booking platforms, custom CRMs, and AI inbound call agents. Free online tools included.",
    keywords:
      "IT services, research services, web development, lead generation website, booking platform, custom CRM, AI call agent, Purpose Labs, worldwide",
    path: "/",
  },
  tools: {
    title: "Daily Innovations — Free Online Tools",
    description:
      "Browse free online tools by Purpose Labs — YouTube, Instagram, and Twitter downloaders, DOC to PDF, image to PDF, and video to MP3 converters. No signup required.",
    keywords:
      "free online tools, video downloader, youtube downloader, instagram downloader, doc to pdf, image to pdf, video to mp3, Purpose Labs",
    path: "/tools",
  },
};

export function getCanonicalPath(path) {
  if (!path || path === "/") return SITE_URL;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function formatPageTitle(title) {
  if (title.includes(SITE_NAME)) return title;
  return `${title} | ${SITE_NAME}`;
}

export function getToolPageMeta(tool) {
  return {
    title: `${tool.title} — Free Online Tool`,
    description: `${tool.description} Free, fast, and browser-based — no account required.`,
    keywords: [tool.title, ...(tool.tags || []), SITE_NAME, "free online tool"].join(", "),
    path: `/tools/${tool.slug}`,
  };
}

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: SITE_NAME,
    url: SITE_URL,
    logo: OG_IMAGE,
    email: siteConfig.email,
    telephone: siteConfig.phone,
    description: siteConfig.description,
    sameAs: [],
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: SITE_NAME,
    url: SITE_URL,
    description: siteConfig.description,
    publisher: { "@id": `${SITE_URL}/#organization` },
    inLanguage: "en",
  };
}

export function webApplicationSchema(tool) {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: tool.title,
    url: getCanonicalPath(`/tools/${tool.slug}`),
    description: tool.description,
    applicationCategory: "UtilitiesApplication",
    operatingSystem: "Any",
    browserRequirements: "Requires JavaScript",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
    provider: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: getCanonicalPath(item.path),
    })),
  };
}

export const sitemapRoutes = [
  { path: "/", changefreq: "weekly", priority: "1.0" },
  { path: "/tools", changefreq: "weekly", priority: "0.9" },
  ...tools.map((tool) => ({
    path: `/tools/${tool.slug}`,
    changefreq: "monthly",
    priority: "0.8",
  })),
];
